import Vue from 'vue'
import { Mixin } from 'vue-mixin-decorator'

@Mixin
export default class BfcacheHandler extends Vue {
  // bfcacheから状態が復元された場合にkeyをインクリメントする
  // これをkeyとして利用すれば、bfcacheから復元されたDOMを再描画することができる
  protected renderingKey: number = 0

  registerBfcacheHandler(): void {
    window.addEventListener('pageshow', this.incrementRenderingKeyIfPersisted)
  }

  unregisterBfcacheHandler(): void {
    window.removeEventListener('pageshow', this.incrementRenderingKeyIfPersisted)
  }

  // bfcacheから復元された場合にkeyをインクリメントする
  private incrementRenderingKeyIfPersisted(event: PageTransitionEvent): void {
    if (event.persisted) {
      this.renderingKey = this.renderingKey + 1
    }
  }
}
